import {emptyValidator, formValidator} from "../../validators";

const ApprovalProcessCreationStatus = {

    apmStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    // apmReason: {
    //     validators: [emptyValidator()],
    //     name: "Reason",
    // },

};
export const approvalProcessValidation = (approvalData) => {
    return formValidator(approvalData, ApprovalProcessCreationStatus);
};
